import { EXO_SKELETON_RUNTIME_SCOPE } from './consts';

export interface RemoteInfo {
  scope: string;
  url: string;
}

export interface RuntimeRemoteInfo {
  /**
   * Returns the remote info from the ExoSkeleton host
   * @returns {Promise<RemoteInfo>}
   * @example
   *
   * const remoteInfo = await get();
   * console.log(remoteInfo);
   * // { scope: 'my-scope', url: 'https://assets.my-scope.acc.autodesk.com/assets-no-cache/remoteEntry.js' }
   */
  get(): Promise<RemoteInfo>;
}

declare global {
  interface Window {
    [EXO_SKELETON_RUNTIME_SCOPE]?: {
      available?: boolean;
      remotes?: Record<string, RuntimeRemoteInfo>;
    };
  }
}

export function getExoSkeletonRuntime(host: Window | WindowProxy = window) {
  if (!host[EXO_SKELETON_RUNTIME_SCOPE]) {
    host[EXO_SKELETON_RUNTIME_SCOPE] = {};
  }

  return host[EXO_SKELETON_RUNTIME_SCOPE];
}

/**
 * Should be used by an ExoSkeleton host
 */
export function setIsInExoSkeleton() {
  const runtime = getExoSkeletonRuntime();

  runtime.available = true;
}

/**
 * Should be used by an ExoSkeleton host
 */
export function setExoSkeletonRemotes(
  remotes: Record<string, RuntimeRemoteInfo>,
) {
  const runtime = getExoSkeletonRuntime();

  runtime.remotes = remotes;
}

export function createUniqueRequestId(prefix = '') {
  return `${prefix}${Math.random().toString(16).slice(2)}`;
}

export function notInExoSkeletonError({ source }: { source: string }) {
  return new Error(
    `Cannot execute "${source}" outside of the ExoSkeleton, please use "setIsInExoSkeleton" to set the runtime environment`,
  );
}
